<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE PA'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label><small v-show="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o nome do funcionário'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label ><small v-show="form.matricula.required" class="text-danger">*</small> Matrícula:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o numero de matrícula'"
                          v-model="form.matricula.value"
                          :size="form.matricula.maxlength"
                          :required="form.matricula.required"
                          :state="form.matricula.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-6 pt-3">
          <label><small v-show="form.cpf.required" class="text-danger">*</small> CPF:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o CPF'"
                          v-model="form.cpf.value"
                          :size="form.cpf.maxlength"
                          :required="form.cpf.required"
                          :state="form.cpf.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>

        <div class="col-md-6 pt-3">
          <label><small v-show="form.email.required" class="text-danger">*</small> E-mail:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o E-mail'"
                          v-model="form.email.value"
                          :size="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>

        <div class="col-md-6 pt-3">
          <label><small v-show="form.celular.required" class="text-danger">*</small> Celular:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Celular'"
                          v-model="form.celular.value"
                          :size="form.celular.maxlength"
                          :required="form.celular.required"
                          :state="form.celular.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>

        <div class="col-md-6 pt-3">
          <label><small v-show="form.cargo.required" class="text-danger">*</small> Cargo:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Cargo'"
                          v-model="form.cargo.value"
                          :size="form.cargo.maxlength"
                          :required="form.cargo.required"
                          :state="form.cargo.state"
                          autocomplete="false"></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import PositionModel from '@/shared/models/configurations/positionmodel.js'
import PositionForms from './position-form.js'
import PositionRepository from '@/shared/http/repositories/configurations/position.js'

export default {
  name: 'PaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: PositionModel,
      form: PositionForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      if (obj && obj.numero) {
        this.form.numero.value = parseInt(obj.numero)
      }
      loading.pop()
    },
    onCreate () {
      loading.push()
      PositionRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      PositionRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/position/components/add/positionAdd.vue